@if (client$ | async; as client) {
  @if (diensten$ | async; as diensten) {
    <div class="content">
      <h3>{{client.getNaam()}}</h3>
      <zah-client-diensten-beheer [(clientDiensten)]="client.diensten"
        [diensten]="diensten">
      </zah-client-diensten-beheer>
      <div class="actions">
        <button mat-button
          color="primary"
          type="button"
          (click)="onCancelClicked(client)">
          Annuleer
        </button>
        <button mat-raised-button
          color="primary"
          type="submit"
          (click)="onOkClicked(client)">
          Bewaar
        </button>
      </div>
    </div>
  }
}
